import { WidgetDefinition } from '../models/WidgetDefinition';

export const approvalTableWidgetDefinition: WidgetDefinition = {
    baseType: 'approvalTable',
    group: 'Charts',
    hasImage: true,
    highlights: ['Table with approval/rejection information of current group'],
    icon: 'fa-thumbs-o-up',
    sortingOrder: 1400,
    title: 'Approval table',
    type: 'approvalTable'
};